import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import store, { epic$ } from './store';
//import bsHistory from './browserHistory';
import { Switch, Route, useLocation } from 'react-router-dom';
import { startModule, endModule, resetSessionTimeout, RDX_APP_API_INIT } from '../redux/appAction';
import { appendIntl } from '../redux/intlAction';
import { updateSession } from '../redux/sessionAction';
import { navigateDone } from '../redux/navAction';
import { resetNotify } from '../redux/notifyAction';
import routerConfig from '../router/routerConfig';
import SusLoading from '../component/common/Loader';
//import { LOCALES } from 'approot/page/app/constant';
//import commonConfig from 'config/commonConfig';

const getRouterFunc = (target) => {
	const matchFunc = routerConfig.filter(func => target === func.path);
	if (matchFunc.length > 0) {
		return matchFunc[0];
	} else {
		return null;
	}
};

const loadIntl = async (routerFunc) => {
	if (routerFunc && routerFunc.intl) {
		const intl = await routerFunc.intl();
		store.dispatch(appendIntl(intl.default));
	}
};

const removeReducer = (routerFunc) => {
	if (routerFunc && routerFunc.redux) {
		store.reducerManager.remove(routerFunc.redux.key);
	}
};

const loadReducer = async (routerFunc) => {
	if (routerFunc && routerFunc.redux) {
		const rdcer = await routerFunc.redux.reducer();
		store.reducerManager.add(routerFunc.redux.key, rdcer.default);
	}
};

const loadEpic = async (routerFunc) => {
	if (routerFunc.epic) {
		const ep = await routerFunc.epic();
		epic$.next(ep.default);
	}
};

const loadFuncResource = async (target, state) => {
	const routerFunc = getRouterFunc(target);
	if (routerFunc) {
		loadIntl(routerFunc);
		removeReducer(routerFunc);
		await loadReducer(routerFunc);
		if (state.indexOf(target) === -1) {
			await loadEpic(routerFunc);
			return true;
		}
	}
	return false;
};

// const extractJson = (url) => {
// 	const decodeUrl = decodeURIComponent(url);
// 	console.log('decodeUrl is ', decodeUrl);
// 	const qs = decodeUrl.split('=')[1];
// 	console.log('jsonData is ', qs);
// 	let qs1 = '';
// 	if (qs) {
// 		if (qs.indexOf('#/') !== -1) {
// 			qs1 = qs.substr(0, qs.length - 2);
// 		}
// 		console.log('qs after substr is ', qs1);
// 		qs1 = atob(qs1);
// 		qs1 = JSON.parse(qs1);
// 		console.log('decode jsonData=> ', qs1);
// 	}
// 	return qs1;
// };

// const parseQS = (qs) => {
// 	if (qs) {
// 		qs.targetFunc = commonConfig.logonDefaultValue.targetFunction;
// 		qs.chnlID = commonConfig.logonDefaultValue.ChannelID;
// 		if (qs.staffId) {
// 			qs.staffID = qs.staffId;
// 		}
// 		if (qs.LOB) {
// 			qs.lob = qs.LOB;
// 		}
// 		if (qs.questionnaireType === 'CCTPR' && qs.jointCustID && !qs.custID) {
// 			qs.custID = qs.jointCustID;
// 		}
// 		if (qs.questionnaireType === 'CCTPR' && qs.customerDetails) {
// 			qs.customerDetails = JSON.parse(qs.customerDetails);
// 			console.log('Loader, simon test customer title, first name and last name', qs.customerDetails);
// 		}
// 	}
// 	return qs;
// };

export {loadIntl, loadReducer, loadEpic};

export default function Loader() {
	const dispatch = useDispatch();
	const location = useLocation();
	const locale = useSelector(state => state.session.locale);
	const navTransientPeriod = useSelector(state => state.nav.transientPeriod);

	const [lazyModules, addLazyModules] = useState([]);
	const [isLazyReady, updateLazyReady] = useState(false);
	const [isLocaleReady, updateLocaleReady] = useState(false);

	// init app data effect
	useEffect(
		() => {
			console.log('window.location.href', window.location.href);
			const decodeUrl = window.location.href;
			//const qs = extractJson('http://localhost:3000/esg-qas-ui/#/esgHome?model=WDS');//'http://localhost:3001//esg-qas-ui/?jsonData=eyJjaG5sSUQiOiJPSEIiLCJsb2NhbGUiOiJlbl9VUyIsInN0YWZmSUQiOiIyOTAwMDEwMSIsInRpbWV6b25lIjoiIiwibGVhZElEIjoiIiwiY2hubENDIjoiU0ciLCJjaG5sR01DIjoiSEJTUCIsImN1c3RUeXBlIjoiQ0RNIiwiY3VzdElEIjoiU0dIQlNQMTQ3ODczMTYwIiwicHJvc3BlY3RJRCI6IiIsImN1c3RDQyI6IlNHIiwiY3VzdEdNQyI6IkhCU1AiLCJodWJVc2VySWQiOiJXRDAxIiwiaHViVXNlckRldmljZUlkIjoiV0QwMSIsImJpekxpbmUiOiJQRlMiLCJzb3VyY2VGdW5jIjoiZG9jdW1lbnRDZW50ZXIiLCJjdXN0b21lck5hbWUiOiJGTlNHIEhCU1AgMTQ3LSBaR0MiLCJTRlBfVVJMIjoiaHR0cHM6Ly9zdGFmZi53ZWFsdGgtcGxhdGZvcm0tc2doLnNpdC5hd3MuY2xvdWQuaHNiYy9ncm91cC1zZnAtdWktd2FyLyJ9');
			const qs = decodeUrl.split('=')[1];
			const localStr = decodeUrl.split('/')[4];
			console.log('qs', qs);
			const sessionInit = {
				modal: qs, 
				localStr: localStr
			};
			dispatch(updateSession({...sessionInit }));
			// if (qs) {
			// 	const qsJson = parseQS(qs);
			// 	console.log('qsJson', qsJson);
			// 	if (!qsJson.locale || !LOCALES.includes(qsJson.locale)) {
			// 		qsJson.locale = LOCALES[0];
			// 	}
			// 	qsJson.localeIntl = qsJson.locale.replace('_', '-');
			// 	console.log(qsJson);
			// 	if (qsJson.targetFunc) {
			// 		// @@WP-REACT: customize some init step when first launch ui
			// 		// ...
			// 		const chnlID = (qsJson.chnlID === 'OHB') ? 'OHB' : 'OHI';
			// 		const sessionInit = {
			// 			isDualRecordOn: false, isSuperVisorMode: false,
			// 			calculateResult: '', currentAnswers: []
			// 		};
			// 		dispatch(updateSession({ ...qsJson, ...sessionInit }));
			// 		// after update session, we should remove qs from url
			// 		bsHistory.push(process.env.REACT_APP_WEB_ROOT);
			// 		if (chnlID === 'OHB') {
			// 			if (qsJson.chnlCC === 'HK'){
			// 				// read staff full name
			// 				dispatch({ type: RDX_OHB_SESSION_INIT });
			// 			}
			// 			dispatch({ type: RDX_APP_GEN_DSP_AMTOKEN, 'isNavigate': true });
			// 		}
			// 	}
			// }
		}, [dispatch]
	);

	// lazy load function resource (intl, reducer, epic etc)
	useEffect(
		() => {
			updateLazyReady(false);
			dispatch(startModule());
			dispatch(resetNotify());
			dispatch({ type: RDX_APP_API_INIT });
			dispatch(navigateDone());
			dispatch(resetSessionTimeout());
			const currentFunction = location.pathname;
			loadFuncResource(currentFunction, lazyModules).then(
				(addFunSucc) => {
					if (addFunSucc) {
						addLazyModules([...lazyModules, currentFunction]);
					}
					dispatch(endModule());
					updateLazyReady(true);
				}
			);
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [location.pathname, dispatch]
	);

	// locale change , force reload function
	useEffect(
		() => {
			updateLocaleReady(false);
			dispatch(resetNotify());
			// @@WP-REACT: customize step to update cookie for GSP integration
			// ...
			const to = setTimeout(
				() => {
					updateLocaleReady(true);
					clearTimeout(to);
				}, 300
			);
		}, [locale, dispatch]
	);

	return (
		<>
			{isLocaleReady ?
				<>
					{!navTransientPeriod && isLazyReady ?

						<Switch>
							{/* <Route path="fakeLoader" exact={true} component={FakeLoader} /> */}
							{routerConfig.map(
								(func) => (
									<Route key={func.path} path={func.path} component={func.component} />
								))
							}
						</Switch>
						: <SusLoading />}
				</>
				: <SusLoading />}
		</>
	);
}
